import React, { useState, useEffect } from 'react';

const GlitchText = ({ children, className = '', as: Component = 'span', alwaysActive = false }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [staticOffset, setStaticOffset] = useState({ x: 0, y: 0 });

  const isActive = alwaysActive || isHovered;

  useEffect(() => {
    if (!isActive) return;
    
    let animationId;
    let time = 0;
    
    const animateStatic = () => {
      time += 0.05;
      const staticX = Math.sin(time * 3) * 1.5 + Math.sin(time * 7) * 0.5;
      const staticY = Math.cos(time * 2) * 0.8 + Math.cos(time * 5) * 0.3;
      setStaticOffset({ x: staticX, y: staticY });
      animationId = requestAnimationFrame(animateStatic);
    };
    
    animateStatic();
    return () => { if (animationId) cancelAnimationFrame(animationId); };
  }, [isActive]);

  return (
    <Component
      className={`relative cursor-pointer select-none inline-block ${className}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => { setIsHovered(false); setStaticOffset({ x: 0, y: 0 }); }}
      style={{
        color: isActive ? 'transparent' : undefined,
        background: isActive 
          ? 'linear-gradient(135deg, #fff 0%, #a78bfa 20%, #f472b6 40%, #60a5fa 60%, #34d399 80%, #fff 100%)'
          : undefined,
        backgroundSize: isActive ? '400% 400%' : undefined,
        WebkitBackgroundClip: isActive ? 'text' : undefined,
        backgroundClip: isActive ? 'text' : undefined,
        animation: isActive ? 'gradientFlow 4s ease infinite' : undefined,
      }}
    >
      {children}
      
      {isActive && (
        <>
          <span 
            className="absolute inset-0 pointer-events-none"
            style={{
              color: 'rgba(255, 80, 80, 0.6)',
              transform: `translate(${staticOffset.x + 1.5}px, ${staticOffset.y}px)`,
              filter: 'blur(0.3px)',
            }}
            aria-hidden="true"
          >
            {children}
          </span>
          <span 
            className="absolute inset-0 pointer-events-none"
            style={{
              color: 'rgba(80, 255, 120, 0.5)',
              transform: `translate(${-staticOffset.x * 0.7}px, ${staticOffset.y * 1.2}px)`,
              filter: 'blur(0.2px)',
            }}
            aria-hidden="true"
          >
            {children}
          </span>
          <span 
            className="absolute inset-0 pointer-events-none"
            style={{
              color: 'rgba(80, 150, 255, 0.6)',
              transform: `translate(${staticOffset.x * 0.5}px, ${-staticOffset.y * 0.8}px)`,
              filter: 'blur(0.3px)',
            }}
            aria-hidden="true"
          >
            {children}
          </span>
        </>
      )}

      <style>{`
        @keyframes gradientFlow {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
    </Component>
  );
};

export default GlitchText;
